/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isForcedMotionValue as o}from"../../../motion/utils/is-forced-motion-value.js";import{isMotionValue as t}from"../../../value/utils/is-motion-value.js";function i(i,s){const{style:e}=i,n={};for(const r in e)(t(e[r])||s.style&&t(s.style[r])||o(r,i))&&(n[r]=e[r]);return n}export{i as scrapeMotionValuesFromProps};
//# sourceMappingURL=scrape-motion-values.js.map
